/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PhotoFormat {
}

export enum PhotoFormat_Enum {
  PHOTO_FORMAT_DEFAULT = 0,
  PHOTO_FORMAT_JPEG = 1,
  PHOTO_FORMAT_RAW = 2,
  PHOTO_FORMAT_DNG = 3,
  PHOTO_FORMAT_JPEG_AND_DNG = 4,
  PHOTO_FORMAT_YUV = 5,
  PHOTO_FORMAT_RJPEG = 6,
  UNRECOGNIZED = -1,
}

export function photoFormat_EnumFromJSON(object: any): PhotoFormat_Enum {
  switch (object) {
    case 0:
    case "PHOTO_FORMAT_DEFAULT":
      return PhotoFormat_Enum.PHOTO_FORMAT_DEFAULT;
    case 1:
    case "PHOTO_FORMAT_JPEG":
      return PhotoFormat_Enum.PHOTO_FORMAT_JPEG;
    case 2:
    case "PHOTO_FORMAT_RAW":
      return PhotoFormat_Enum.PHOTO_FORMAT_RAW;
    case 3:
    case "PHOTO_FORMAT_DNG":
      return PhotoFormat_Enum.PHOTO_FORMAT_DNG;
    case 4:
    case "PHOTO_FORMAT_JPEG_AND_DNG":
      return PhotoFormat_Enum.PHOTO_FORMAT_JPEG_AND_DNG;
    case 5:
    case "PHOTO_FORMAT_YUV":
      return PhotoFormat_Enum.PHOTO_FORMAT_YUV;
    case 6:
    case "PHOTO_FORMAT_RJPEG":
      return PhotoFormat_Enum.PHOTO_FORMAT_RJPEG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoFormat_Enum.UNRECOGNIZED;
  }
}

export function photoFormat_EnumToJSON(object: PhotoFormat_Enum): string {
  switch (object) {
    case PhotoFormat_Enum.PHOTO_FORMAT_DEFAULT:
      return "PHOTO_FORMAT_DEFAULT";
    case PhotoFormat_Enum.PHOTO_FORMAT_JPEG:
      return "PHOTO_FORMAT_JPEG";
    case PhotoFormat_Enum.PHOTO_FORMAT_RAW:
      return "PHOTO_FORMAT_RAW";
    case PhotoFormat_Enum.PHOTO_FORMAT_DNG:
      return "PHOTO_FORMAT_DNG";
    case PhotoFormat_Enum.PHOTO_FORMAT_JPEG_AND_DNG:
      return "PHOTO_FORMAT_JPEG_AND_DNG";
    case PhotoFormat_Enum.PHOTO_FORMAT_YUV:
      return "PHOTO_FORMAT_YUV";
    case PhotoFormat_Enum.PHOTO_FORMAT_RJPEG:
      return "PHOTO_FORMAT_RJPEG";
    case PhotoFormat_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePhotoFormat(): PhotoFormat {
  return {};
}

export const PhotoFormat = {
  encode(_: PhotoFormat, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoFormat {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoFormat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PhotoFormat {
    return {};
  },

  toJSON(_: PhotoFormat): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoFormat>, I>>(base?: I): PhotoFormat {
    return PhotoFormat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoFormat>, I>>(_: I): PhotoFormat {
    const message = createBasePhotoFormat();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
